import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FilterTabs, type FilterTabOption } from "@/components/ui/customs/filter-tabs";

const INACTIVE_TAB = "text-gray-500 hover:bg-gray-100";
const INACTIVE_BADGE = "bg-gray-500/10 text-gray-500";

export type BlockedView = "blocked" | "unblocked";

const useStatusOptions = (): FilterTabOption[] => {
  const { t } = useTranslation("boExpeditions");
  return useMemo(
    () => [
      {
        label: t("blockedStatusBox.blocked"),
        value: "blocked",
        width: "w-28",
        activeClassName: "bg-orange-500 text-white",
        inactiveClassName: INACTIVE_TAB,
        badgeActiveClassName: "bg-white/20 text-white",
        badgeInactiveClassName: INACTIVE_BADGE,
      },
      {
        label: t("blockedStatusBox.unblocked"),
        value: "unblocked",
        width: "w-fit sm:ml-5",
        activeClassName: "bg-green-600 text-white",
        inactiveClassName: INACTIVE_TAB,
        badgeActiveClassName: "bg-white/20 text-white",
        badgeInactiveClassName: INACTIVE_BADGE,
      },
    ],
    [t],
  );
};

type Props = {
  view: BlockedView;
  onViewChange: (view: BlockedView) => void;
  counts?: { blocked?: number; unblocked?: number };
};

export const BlockedExpeditionsStatusBox = ({ view, onViewChange, counts }: Props) => {
  const statusOptions = useStatusOptions();
  const countsMap = new Map<string | null, number | undefined>([
    ["blocked", counts?.blocked],
    ["unblocked", counts?.unblocked],
  ]);

  return (
    <div className="my-2 flex w-full flex-col gap-2 sm:flex-row sm:items-center">
      <FilterTabs
        options={statusOptions}
        value={view}
        onChange={(v) => onViewChange(v as BlockedView)}
        counts={countsMap}
        className="w-full flex-col !border-none !bg-transparent !shadow-none sm:w-fit sm:flex-row"
      />
    </div>
  );
};
